/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  createDurability,
  createDynamicColumn,
  deleteDurability,
  editDurability,
  getAcn,
  getDppDurability,
  getDppIds,
  getDynamicColumn,
  getItemMaster,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocation,
  getSubModulesByRoleId,
  getWarehouses,
  getWarehousesByMovement,
  getZonesByWarehouse,
  uploadForDurability,
} from "../../../store";

// Cookies
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import UploadButton from "components/standardized-components/UploadButton";
import { addMinutes, format } from "date-fns";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: 350, lg: 900 },
  height: { xs: 250, lg: 700 },
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflow: "auto",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Durability = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteDurability,
  warehouses,
  getDppDurability,
  getDppDurabilityReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editDurability,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createDurability,
  getWarehousesByMovement,
  uploadForDurability,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,
  getDppIds,
  getDynamicColumnReducer,
  getDPPReducer,
  dppIdSelectedForGlobalFilter,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "5e690abe-d7a1-4e45-8782-43409b4edab2",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "f6af66fa-cf82-44a1-87db-903f94e9fa5f",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "24059d11-ee70-4a0d-a132-56bf7195de49",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "24185f9e-99aa-47e5-a099-9e34808ac08a",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "71803ca0-8cee-4663-b309-009a56aaa87f",
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getDppDurability(jwtToken);
  // }, []);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "ID", accessor: "durabilityId" },
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "Lifespan (Years) ", accessor: "expectedLifespan" },
      { Header: "Drop Test (Meters)", accessor: "dropTest" },
      { Header: "Temp Range (°C)", accessor: "temperatureRange" },
      { Header: "Material", accessor: "materialStrength" },
      { Header: "Warranty", accessor: "warranty" },
      // {
      //   Header: "Audit Date",

      //   accessor: "cd",
      //   align: "left",
      //   searchType: "date",
      //   Cell: ({ value }) => {
      //     return value
      //       ? format(
      //           addMinutes(
      //             new Date(value),
      //             new Date(value).getTimezoneOffset()
      //           ),
      //           "dd/MM/yyyy hh:mm aaa"
      //         )
      //       : "";
      //   },
      // },

      { Header: "Quality Score (1 to 10)", accessor: "qualityScore" },
      { Header: "State of Health", accessor: "stateOfHealth" },
      { Header: "Efficiency", accessor: "efficiency" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  // const headers = [
  //   { label: "durabilityId", key: "durabilityId" },
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "expectedLifespan", key: "expectedLifespan" },
  //   { label: "dropTest", key: "dropTest" },
  //   { label: "temperatureRange", key: "temperatureRange" },
  //   { label: "materialStrength", key: "materialStrength" },
  //   { label: "warranty", key: "warranty" },
  //   { label: "qualityScore", key: "qualityScore" },
  //   { label: "stateOfHealth", key: "stateOfHealth" },
  //   { label: "efficiency", key: "efficiency" },

  //   // Action (optional)
  //   // { label: "action", key: "action" }
  // ];
  // const headersForTemp = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "expectedLifespan", key: "expectedLifespan" },
  //   { label: "dropTest", key: "dropTest" },
  //   { label: "temperatureRange", key: "temperatureRange" },
  //   { label: "humidityResistance", key: "humidityResistance" },
  //   { label: "materialStrength", key: "materialStrength" },
  //   { label: "wearResistance", key: "wearResistance" },
  //   { label: "batteryDegradation", key: "batteryDegradation" },
  //   { label: "warranty", key: "warranty" },
  //   { label: "testResults", key: "testResults" },
  //   { label: "qualityScore", key: "qualityScore" },
  //   { label: "orderNo", key: "orderNo" }
  // ];

  // --- 1. Table Data Download (Listing) ke Headers ---
  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Expected Lifespan", key: "expectedLifespan" },
    { label: "Drop Test Height", key: "dropTestHeight" },
    { label: "Temperature Range", key: "temperatureRange" },
    { label: "Material Strength", key: "materialStrength" },
    { label: "Wear Resistance", key: "wearResistance" },
    { label: "Warranty", key: "warranty" },
    { label: "Test Results", key: "testResults" },
    { label: "Quality Score", key: "qualityScore" },

    // { label: "Durability ID", key: "durabilityId" },
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "expectedLifespan", key: "expectedLifespan" },
    { label: "dropTestHeight", key: "dropTestHeight" },
    { label: "temperatureRange", key: "temperatureRange" },
    { label: "materialStrength", key: "materialStrength" },
    { label: "wearResistance", key: "wearResistance" },
    { label: "warranty", key: "warranty" },
    { label: "testResults", key: "testResults" },
    { label: "qualityScore", key: "qualityScore" },
  ];

  const csvLink = {
    filename: "Durability List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Durability Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getDppDurabilityReducer.durability.data
      ? getDppDurabilityReducer.durability.data
      : [];
    // setPaginationObj(getDppDurabilityReducer?.durability?.pagination);
    setLoading(getDppDurabilityReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.cd);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        durabilityId: item.durabilityId,
        dppCode: item.dppCode,
        expectedLifespan: item.expectedLifespan,
        dropTest: item.dropTest,
        temperatureRange: item.temperatureRange,
        materialStrength: item.materialStrength,
        warranty: item.warranty,
        qualityScore: item.qualityScore,
        stateOfHealth: String(item.stateOfHealth || ""),
        efficiency: String(item.efficiency || ""),

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getDppDurabilityReducer]);

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    [],
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});

    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setSelectedIndustry(null);

    setdppIdSelected("");
    formik.setValues(initialValues);
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName,
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  const initialValues = {
    DPPID: "",
    ExpectedLifeSpan: "",
    DropTest: "",
    TemperatureRange: "",
    HumidityResistance: "",
    MaterialStrength: "",
    WearResistance: "",
    BatteryDegradation: "",
    Warranty: "",
    QualityScore: "",
    TestResults: "",
    stateOfHealth: "",
    efficiency: "",
    // rackName: "",
    // bin: "",
  };

  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const validationSchema = Yup.object({
    ExpectedLifeSpan: Yup.string().required(" "),
    DropTest: Yup.string().required(" "),
    TemperatureRange: Yup.string().required(" "),

    HumidityResistance:
      selectedIndustry !== 9
        ? Yup.string()
        : // required(" ")
        Yup.string(),

    MaterialStrength:
      selectedIndustry !== 1 ? Yup.string().required(" ") : Yup.string(),

    WearResistance:
      selectedIndustry !== 1 ? Yup.string().required(" ") : Yup.string(),

    BatteryDegradation:
      selectedIndustry !== 1
        ? Yup.string()
        : // .required(" ")
        Yup.string(),

    // AbrasionResistance:
    //   selectedIndustry === 1
    //     ? Yup.string().required("Abrasion Resistance is required")
    //     : Yup.string(),

    // ColorFastness:
    //   selectedIndustry === 1
    //     ? Yup.string().required("Color Fastness is required")
    //     : Yup.string(),

    // ShrinkagePercentage:
    //   selectedIndustry === 1
    //     ? Yup.string().required("Shrinkage Percentage is required")
    //     : Yup.string(),

    // PillingResistance:
    //   selectedIndustry === 1
    //     ? Yup.string().required("Pilling Resistance is required")
    //     : Yup.string(),

    Warranty: Yup.string().required(" "),
    QualityScore: Yup.string().required(" "),
    TestResults: Yup.string().required(" "),
    stateOfHealth: Yup.number()
      .typeError("Must be a number")
      .positive("Must be a positive value"),
    // .required(" "),
    efficiency: Yup.number()
      .typeError("Must be a number")
      .positive("Must be a positive value"),
    // .required(" "),
  });

  const handleDPPChange = (option) => { };
  const [dppIdSelected, setdppIdSelected] = useState("");

  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);

    setSelectedIndustry(selectedData?.industry);
    formik.setFieldValue("dppId", selectedData?.value);
  };

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getDppDurability(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getDppDurability(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
        industry: zone.industryId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  useEffect(() => {
    getDppIds(jwtToken);
  }, []);

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");
    const payload = {
      cdBy: String(userId ?? ""),
      dppId: String(dppIdSelected?.value ?? ""),
      expectedLifespan: String(values.ExpectedLifeSpan ?? ""),
      dropTest: String(values.DropTest ?? ""),
      temperatureRange: String(values.TemperatureRange ?? ""),

      ...(selectedIndustry === 1
        ? {
          abrasionResistance: String(values.AbrasionResistance ?? ""),
          colorFastness: String(values.ColorFastness ?? ""),
          shrinkagePercentage: String(values.ShrinkagePercentage ?? ""),
          pillingResistance: String(values.PillingResistance ?? ""),
        }
        : {
          humidityResistance: String(values.HumidityResistance ?? ""),
          materialStrength: String(values.MaterialStrength ?? ""),
          wearResistance: String(values.WearResistance ?? ""),
          batteryDegradation: String(values.BatteryDegradation ?? ""),
        }),

      warranty: String(values.Warranty ?? ""),
      qualityScore: String(values.QualityScore ?? ""),
      testResults: String(values.TestResults ?? ""),
      stateOfHealth: String(values.stateOfHealth ?? ""),
      efficiency: String(values.efficiency ?? ""),
    };

    console.log("payload", payload);
    let res = await createDurability(payload, jwtToken);
    if (res.status) {
      setIsSuccessAllocateItem(true);
      // getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getDppDurability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});
      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");
      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    }
    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }
    setSelectedItemCode("");
    setSelectedZoneName("");
    setSelectedBin("");
    // resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let durabilityId = singleDataForDelete.durabilityId;
    // let userId = singleDataForDelete.userId;

    let res = await deleteDurability(durabilityId);

    if (res.status) {
      getDppDurability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getDppDurability(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    setWarehouseTypesSelectedForEdit({
      label: singleData.warehouseCode,
      value: singleData.warehouseId,
    });
    setItemCodeSelectedForEdit({
      label: singleData.itemCode,
      value: singleData.itemId,
    });
    setAcnTypeSelectedForEdit({
      label: singleData.acnCode,
      value: singleData.acnId,
    });
    setZoneSelectedForEdit({
      label: singleData.zone,
      value: singleData.zoneId,
    });
    setSectionSelectedForEdit({
      label: singleData.section,
      value: singleData.sectionId,
    });
    setRackSelectedForEdit({
      label: singleData.rack,
      value: singleData.rackId,
    });
    setLocationSelectedForEdit({
      label: singleData.location,
      value: singleData.locationId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.dppCode,
    ExpectedLifespan: singleFgDataForUpdate.expectedLifespan,
    DropTest: singleFgDataForUpdate.dropTest,
    TemperatureRange: singleFgDataForUpdate.temperatureRange,
    HumidityResistance: singleFgDataForUpdate.humidityResistance,
    MaterialStrength: singleFgDataForUpdate.materialStrength,
    WearResistance: singleFgDataForUpdate.wearResistance,
    BatteryDegradation: singleFgDataForUpdate.batteryDegradation,
    Warranty: singleFgDataForUpdate.warranty,
    QualityScore: singleFgDataForUpdate.qualityScore,
    TestResults: singleFgDataForUpdate.testResults,

    abrasionResistance: singleFgDataForUpdate.abrasionResistance,
    colorFastness: singleFgDataForUpdate.colorFastness,
    shrinkagePercentage: singleFgDataForUpdate.shrinkagePercentage,
    pillingResistance: singleFgDataForUpdate.pillingResistance,
    stateOfHealth: singleFgDataForUpdate.StateofHealth,
    efficiency: singleFgDataForUpdate.Efficiency,
  };

  console.log(
    "singleFgDataForUpdate.pillingResistance",
    singleFgDataForUpdate.pillingResistance,
  );

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const payload = {
      udBy: String(userId),
      durabilityId: String(singleFgDataForUpdate.durabilityId),
      dppId: String(values.DPPID),

      expectedLifespan: String(values.ExpectedLifespan || ""),
      dropTest: String(values.DropTest || ""),
      temperatureRange: String(values.TemperatureRange || ""),

      ...(singleFgDataForUpdate.dppId === 270
        ? {
          abrasionResistance: String(values.abrasionResistance || ""),
          colorFastness: String(values.colorFastness || ""),
          shrinkagePercentage: String(values.shrinkagePercentage || ""),
          pillingResistance: String(values.pillingResistance || ""),
        }
        : {
          humidityResistance: String(values.HumidityResistance || ""),
          materialStrength: String(values.MaterialStrength || ""),
          wearResistance: String(values.WearResistance || ""),
          batteryDegradation: String(values.BatteryDegradation || ""),
          qualityScore: String(values.QualityScore || ""),
          testResults: String(values.TestResults || ""),
          stateOfHealth: String(values.stateOfHealth || ""),
          efficiency: String(values.efficiency || ""),
        }),

      warranty: String(values.Warranty || ""),
      qualityScore: String(values.QualityScore || ""),
      testResults: String(values.TestResults || ""),
      stateOfHealth: String(values.stateOfHealth || ""),
      efficiency: String(values.efficiency || ""),
    };
    let res = await editDurability(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getDppDurability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getDppDurability(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});
 

  const uploadCsvHandler = async () => {
    let data = new FormData();
    data.append("file", uploadCsvData);

    try {
      let res = await uploadForDurability(data, jwtToken);
      if (res?.status === true || res?.data?.status === true) {
        getDppDurability(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);
    } catch (error) { 
      showUploadNotification(error);
    }
  };

  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "5e690abe-d7a1-4e45-8782-43409b4edab2";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getDppDurability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Add Durability"
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}
                <CSVLink {...csvLink}>
                  <DownloadDataButton
                    tooltip="Download Durability List"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {
                  //  uploadFG &&
                  <UploadButton
                    tooltip="Upload CSV"
                    //   disabled={!uploadItem}
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="info"
                    iconOnly
                    onClick={uploadCsvFilterHandler}
                  >
                    <Icon>upload</Icon>
                  </UploadButton>
                }

                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}
              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {/* {loadingForDynamicColumn && ( */}
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
                options={{ draggable: false }}
                // serverSidePagination={true}
                // paginationObj={paginationObj}
                pageNoValue={pageNo}
                rowsPerPageValue={rowsPerPage}
                pageNoProp={importPageNo}
                rowsPerPageProp={importRowsPerPage}
                searchProp={importSearch}
                loading={loading}
                hideColumns={hiddenColumsDetails}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
              />
              {/* )} */}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Expected Lifespan(Years)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="ExpectedLifespan"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ExpectedLifespan}
                              error={
                                formikForUpdate.touched.ExpectedLifespan &&
                                formikForUpdate.errors.ExpectedLifespan &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ExpectedLifespan &&
                              formikForUpdate.errors.ExpectedLifespan && (
                                <TextError
                                  msg={formikForUpdate.errors.ExpectedLifespan}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Drop Test(Meters)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="DropTest"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DropTest}
                              error={
                                formikForUpdate.touched.DropTest &&
                                formikForUpdate.errors.DropTest &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DropTest &&
                              formikForUpdate.errors.DropTest && (
                                <TextError
                                  msg={formikForUpdate.errors.DropTest}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Temperature Range
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="TemperatureRange"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.TemperatureRange}
                              error={
                                formikForUpdate.touched.TemperatureRange &&
                                formikForUpdate.errors.TemperatureRange &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.TemperatureRange &&
                              formikForUpdate.errors.TemperatureRange && (
                                <TextError
                                  msg={formikForUpdate.errors.TemperatureRange}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {singleFgDataForUpdate.industryId !== 1 && (
                          <>
                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                <MDTypography variant="h6">
                                  Humidity Resistance(Hours)
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="HumidityResistance"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={
                                    formikForUpdate.values.HumidityResistance
                                  }
                                  error={
                                    formikForUpdate.touched
                                      .HumidityResistance &&
                                    formikForUpdate.errors.HumidityResistance
                                  }
                                  inputProps={{
                                    style: { height: "10px" },
                                    maxLength: 45,
                                  }}
                                />
                                {formikForUpdate.touched.HumidityResistance &&
                                  formikForUpdate.errors.HumidityResistance && (
                                    <TextError
                                      msg={
                                        formikForUpdate.errors
                                          .HumidityResistance
                                      }
                                    />
                                  )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                <MDTypography variant="h6">
                                  Material Strength
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="MaterialStrength"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={
                                    formikForUpdate.values.MaterialStrength
                                  }
                                  error={
                                    formikForUpdate.touched.MaterialStrength &&
                                    formikForUpdate.errors.MaterialStrength
                                  }
                                  inputProps={{
                                    style: { height: "10px" },
                                    maxLength: 45,
                                  }}
                                />
                                {formikForUpdate.touched.MaterialStrength &&
                                  formikForUpdate.errors.MaterialStrength && (
                                    <TextError
                                      msg={
                                        formikForUpdate.errors.MaterialStrength
                                      }
                                    />
                                  )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1} mb={1}>
                                <MDTypography variant="h6">
                                  Wear Resistance(Cycles)
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="WearResistance"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={formikForUpdate.values.WearResistance}
                                  error={
                                    formikForUpdate.touched.WearResistance &&
                                    formikForUpdate.errors.WearResistance
                                  }
                                  inputProps={{
                                    style: { height: "10px" },
                                    maxLength: 45,
                                  }}
                                />
                                {formikForUpdate.touched.WearResistance &&
                                  formikForUpdate.errors.WearResistance && (
                                    <TextError
                                      msg={
                                        formikForUpdate.errors.WearResistance
                                      }
                                    />
                                  )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1} mb={1}>
                                <MDTypography variant="h6">
                                  Battery Degredation
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="BatteryDegradation"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={
                                    formikForUpdate.values.BatteryDegradation
                                  }
                                  error={
                                    formikForUpdate.touched
                                      .BatteryDegradation &&
                                    formikForUpdate.errors.BatteryDegradation
                                  }
                                  inputProps={{
                                    style: { height: "10px" },
                                    maxLength: 45,
                                  }}
                                />
                                {formikForUpdate.touched.BatteryDegradation &&
                                  formikForUpdate.errors.BatteryDegradation && (
                                    <TextError
                                      msg={
                                        formikForUpdate.errors
                                          .BatteryDegradation
                                      }
                                    />
                                  )}
                              </MDBox>
                            </Grid>
                          </>
                        )}

                        {singleFgDataForUpdate.industryId === 1 && (
                          <>
                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                <MDTypography variant="h6">
                                  Abrasion Resistance(Cycles)
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="abrasionResistance"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={
                                    formikForUpdate.values.abrasionResistance
                                  }
                                />
                                {formikForUpdate.touched.abrasionResistance &&
                                  formikForUpdate.errors.abrasionResistance && (
                                    <TextError
                                      msg={
                                        formikForUpdate.errors
                                          .abrasionResistance
                                      }
                                    />
                                  )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                <MDTypography variant="h6">
                                  Color Fastness(Grade 1-5)
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="colorFastness"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={formikForUpdate.values.colorFastness}
                                />
                                {formikForUpdate.touched.colorFastness &&
                                  formikForUpdate.errors.colorFastness && (
                                    <TextError
                                      msg={formikForUpdate.errors.colorFastness}
                                    />
                                  )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                <MDTypography variant="h6">
                                  Shrinkage Percentage(%)
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="shrinkagePercentage"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={
                                    formikForUpdate.values.shrinkagePercentage
                                  }
                                />
                                {formikForUpdate.touched.shrinkagePercentage &&
                                  formikForUpdate.errors
                                    .shrinkagePercentage && (
                                    <TextError
                                      msg={
                                        formikForUpdate.errors
                                          .shrinkagePercentage
                                      }
                                    />
                                  )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={6}>
                              <MDBox ml={1}>
                                <MDTypography variant="h6">
                                  Pilling Resistance(Grade 1-5)
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="pillingResistance"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={
                                    formikForUpdate.values.pillingResistance
                                  }
                                />
                                {formikForUpdate.touched.pillingResistance &&
                                  formikForUpdate.errors.pillingResistance && (
                                    <TextError
                                      msg={
                                        formikForUpdate.errors.pillingResistance
                                      }
                                    />
                                  )}
                              </MDBox>
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">Warranty</MDTypography>
                            <MDInput
                              type="text"
                              name="Warranty"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Warranty}
                              error={
                                formikForUpdate.touched.Warranty &&
                                formikForUpdate.errors.Warranty &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Warranty &&
                              formikForUpdate.errors.Warranty && (
                                <TextError
                                  msg={formikForUpdate.errors.Warranty}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              Quality Score(1 to 10)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="QualityScore"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.QualityScore}
                              error={
                                formikForUpdate.touched.QualityScore &&
                                formikForUpdate.errors.QualityScore &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.QualityScore &&
                              formikForUpdate.errors.QualityScore && (
                                <TextError
                                  msg={formikForUpdate.errors.QualityScore}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              State of Health (%)
                              {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="stateOfHealth"
                              placeholder="e.g. 20.15"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.stateOfHealth}
                              error={
                                formikForUpdate.touched.stateOfHealth &&
                                formikForUpdate.errors.stateOfHealth &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                step: "any",
                                min: "0",
                              }}
                            />
                            {formikForUpdate.touched.stateOfHealth &&
                              formikForUpdate.errors.stateOfHealth && (
                                <TextError
                                  msg={formikForUpdate.errors.stateOfHealth}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              Efficiency (%)
                              {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="efficiency"
                              placeholder="e.g. 20.15"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.efficiency}
                              error={
                                formikForUpdate.touched.efficiency &&
                                formikForUpdate.errors.efficiency &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                step: "any",
                                min: "0",
                              }}
                            />
                            {formikForUpdate.touched.efficiency &&
                              formikForUpdate.errors.efficiency && (
                                <TextError
                                  msg={formikForUpdate.errors.efficiency}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={12}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              Test Results
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="TestResults"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.TestResults}
                              error={
                                formikForUpdate.touched.TestResults &&
                                formikForUpdate.errors.TestResults &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "40px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.TestResults &&
                              formikForUpdate.errors.TestResults && (
                                <TextError
                                  msg={formikForUpdate.errors.TestResults}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* <Grid item xs={12} lg={6}>
                          <MDBox mb={2} ml={1} >
                            <MDTypography
                            variant="h6"
                              style={{ fontWeight: 500 }}
                              >
                              Status
                              </MDTypography>
                            <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={level4Options}
                              value={locationSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "location",
                                  selectedOption
                                  );
                              }}
                              />
                            {formikForUpdate.touched.location &&
                              formikForUpdate.errors.location && (
                                <TextError
                                msg={formikForUpdate.errors.location}
                                />
                              )}
                              </MDBox>
                        </Grid> */}

                        <Grid item xs={12}>
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Durability Assessment
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginRight: "10px",
                            marginTop: "4px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6">
                            Expected Lifespan(Years)
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="ExpectedLifeSpan"
                            // placeholder="e.g 2.7 Years"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ExpectedLifeSpan}
                            error={
                              formik.touched.ExpectedLifeSpan &&
                              formik.errors.ExpectedLifeSpan &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.ExpectedLifeSpan &&
                            formik.errors.ExpectedLifeSpan && (
                              <TextError msg={formik.errors.ExpectedLifeSpan} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Drop Test(Meters)
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="DropTest"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.DropTest}
                            error={
                              formik.touched.DropTest &&
                              formik.errors.DropTest &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.DropTest &&
                            formik.errors.DropTest && (
                              <TextError msg={formik.errors.DropTest} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6">
                            Temperature Range °C
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="TemperatureRange"
                            // placeholder="e.g. 10°C - 45°C"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.TemperatureRange}
                            error={
                              formik.touched.TemperatureRange &&
                              formik.errors.TemperatureRange &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.TemperatureRange &&
                            formik.errors.TemperatureRange && (
                              <TextError msg={formik.errors.TemperatureRange} />
                            )}
                        </MDBox>
                      </Grid>

                      {selectedIndustry !== 1 && (
                        <>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={2}>
                              <MDTypography variant="h6">
                                Humidity Resistance (Hours)
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="HumidityResistance"
                                // placeholder="e.g Up to 95"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.HumidityResistance}
                                error={
                                  formik.touched.HumidityResistance &&
                                  formik.errors.HumidityResistance &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.HumidityResistance &&
                                formik.errors.HumidityResistance && (
                                  <TextError
                                    msg={formik.errors.HumidityResistance}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox ml={1} mb={2}>
                              <MDTypography variant="h6">
                                Material Strength
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="MaterialStrength"
                                // placeholder="e.g 350 MPa"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.MaterialStrength}
                                error={
                                  formik.touched.MaterialStrength &&
                                  formik.errors.MaterialStrength &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formik.touched.MaterialStrength &&
                                formik.errors.MaterialStrength && (
                                  <TextError
                                    msg={formik.errors.MaterialStrength}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox mb={2}>
                              <MDTypography variant="h6">
                                Wear Resistance(Cycles)
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="WearResistance"
                                fullWidth
                                autoComplete="off"
                                // placeholder="e.g 200 Cycles"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.WearResistance}
                                error={
                                  formik.touched.WearResistance &&
                                  formik.errors.WearResistance &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },

                                  // maxLength: 45,
                                }}
                              />
                              {formik.touched.WearResistance &&
                                formik.errors.WearResistance && (
                                  <TextError
                                    msg={formik.errors.WearResistance}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox ml={1} mb={2}>
                              <MDTypography variant="h6">
                                Battery Degredation %
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="BatteryDegradation"
                                // placeholder="e.g 80%"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.BatteryDegradation}
                                error={
                                  formik.touched.BatteryDegradation &&
                                  formik.errors.BatteryDegradation &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },

                                  // maxLength: 45,
                                }}
                              />
                              {formik.touched.BatteryDegradation &&
                                formik.errors.BatteryDegradation && (
                                  <TextError
                                    msg={formik.errors.BatteryDegradation}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                        </>
                      )}
                      {selectedIndustry === 1 && (
                        <>
                          <Grid item xs={12} lg={6}>
                            <MDBox ml={1}>
                              <MDTypography variant="h6">
                                Abrasion Resistance(Cycles)
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="AbrasionResistance "
                                // placeholder="e.g  95"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.AbrasionResistance}
                              />
                              {formik.touched.AbrasionResistance &&
                                formik.errors.AbrasionResistance && (
                                  <TextError
                                    msg={formik.errors.AbrasionResistance}
                                  />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={6}>
                            <MDBox ml={1}>
                              <MDTypography variant="h6">
                                Color Fastness(Grade 1-5)
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="ColorFastness"
                                // placeholder="e.g  200 Cycles"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.ColorFastness}
                              />
                              {formik.touched.ColorFastness &&
                                formik.errors.ColorFastness && (
                                  <TextError
                                    msg={formik.errors.ColorFastness}
                                  />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={6}>
                            <MDBox ml={1}>
                              <MDTypography variant="h6">
                                Shrinkage Percentage %
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="ShrinkagePercentage"
                                // placeholder="e.g  95"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.ShrinkagePercentage}
                              />
                              {formik.touched.ShrinkagePercentage &&
                                formik.errors.ShrinkagePercentage && (
                                  <TextError
                                    msg={formik.errors.ShrinkagePercentage}
                                  />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={6}>
                            <MDBox ml={1}>
                              <MDTypography variant="h6">
                                Pilling Resistance(Grade 1-5)
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="PillingResistance"
                                // placeholder="e.g  95"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.PillingResistance}
                              />
                              {formik.touched.PillingResistance &&
                                formik.errors.PillingResistance && (
                                  <TextError
                                    msg={formik.errors.PillingResistance}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Warranty</MDTypography>
                          <MDInput
                            type="text"
                            name="Warranty"
                            fullWidth
                            // placeholder="e.g 2 Years"
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Warranty}
                            error={
                              formik.touched.Warranty &&
                              formik.errors.Warranty &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.Warranty &&
                            formik.errors.Warranty && (
                              <TextError msg={formik.errors.Warranty} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Quality Score(1 to 10)
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="QualityScore"
                            fullWidth
                            // placeholder="e.g. 9.5 / 10"
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.QualityScore}
                            error={
                              formik.touched.QualityScore &&
                              formik.errors.QualityScore &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.QualityScore &&
                            formik.errors.QualityScore && (
                              <TextError msg={formik.errors.QualityScore} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            State of Health (%)
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="stateOfHealth"
                            // placeholder="e.g. 20.15"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.stateOfHealth}
                            error={
                              formik.touched.stateOfHealth &&
                              formik.errors.stateOfHealth &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              step: "any",
                              min: "0",
                            }}
                          />
                          {formik.touched.stateOfHealth &&
                            formik.errors.stateOfHealth && (
                              <TextError msg={formik.errors.stateOfHealth} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6">
                            Efficiency (%)
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="efficiency"
                            // placeholder="e.g. 20.15"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.efficiency}
                            error={
                              formik.touched.efficiency &&
                              formik.errors.efficiency &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              step: "any",
                              min: "0",
                            }}
                          />
                          {formik.touched.efficiency &&
                            formik.errors.efficiency && (
                              <TextError msg={formik.errors.efficiency} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={12}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Test Results</MDTypography>
                          <MDInput
                            type="text"
                            name="TestResults"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.TestResults}
                            error={
                              formik.touched.TestResults &&
                              formik.errors.TestResults &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "40px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.TestResults &&
                            formik.errors.TestResults && (
                              <TextError msg={formik.errors.TestResults} />
                            )}
                        </MDBox>
                      </Grid>
                      {/* <Grid item xs={12} lg={12}>
                              <MDBox ml={1} mb={1} >
                                            <MDTypography variant="h6">Proof Document URL</MDTypography>
                                            <MDInput
                                              type="text"
                                              name="SupplierId"
                                              fullWidth
                                              autoComplete="off"
                                              onBlur={formik.handleBlur}
                                              onChange={formik.handleChange}
                                              value={formik.values.SupplierId}
                                              error={
                                                formik.touched.SupplierId &&
                                                formik.errors.SupplierId &&
                                                true
                                              }
                                              inputProps={{
                                                style: {
                                                  height: "10px",
                                                },
                                                
                                                // maxLength: 45,
                                              }}
                                              
                                            />
                                            {formik.touched.SupplierId &&
                                              formik.errors.SupplierId && (
                                                <TextError msg={formik.errors.SupplierId} />
                                              )}
                                          </MDBox>
                      </Grid>
                      */}
                      {/* <Grid item xs={12} lg={12}>
                      <MDBox mb={2}>
  <MDTypography variant="h6">Assesment Date</MDTypography>
  <MDInput
    type="date"  // Change this from "text" to "date"
    name="Collection"
    fullWidth
    autoComplete="off"
    onBlur={formik.handleBlur}
    onChange={formik.handleChange}
    value={formik.values.Collection}
    error={formik.touched.Collection && formik.errors.Collection && true}
    inputProps={{
      style: {
        height: "10px",
      },
    }}
  />
  {formik.touched.Collection && formik.errors.Collection && (
    <TextError msg={formik.errors.Collection} />
  )}
</MDBox>

                      </Grid> */}
                      {/* <Grid item xs={12} lg={6}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Warehouse Code{" "}
                          </MDTypography>

                          <Select
                            isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="warehouseCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "warehouseCode" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={warehouseOptionsByMovement}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "warehouseCode",
                                selectedOption
                              );
                              getLevel1ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel2ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel3ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                              getLevel4ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken
                              );
                            }}
                          />
                          {formik.touched.warehouseCode &&
                            formik.errors.warehouseCode && (
                              <TextError msg={formik.errors.warehouseCode} />
                            )}
                        </MDBox>
                      </Grid> */}

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={allocateButtonName === "Please wait..."}
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getDppDurabilityReducer: state.getDppDurabilityReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getDppDurability: (dppId, jwtToken) =>
      dispatch(getDppDurability(dppId, jwtToken)),
    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createDurability: (payload, jwtToken) =>
      dispatch(createDurability(payload, jwtToken)),
    deleteDurability: (durabilityId, jwtToken) =>
      dispatch(deleteDurability(durabilityId, jwtToken)),
    uploadForDurability: (payload, jwtToken) =>
      dispatch(uploadForDurability(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editDurability: (payload, jwtToken) =>
      dispatch(editDurability(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Durability);
